import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orderbook-separator" }
const _hoisted_2 = { class: "orderbook-separator__item" }
const _hoisted_3 = { class: "orderbook-separator__label" }
const _hoisted_4 = { class: "orderbook-separator__value" }
const _hoisted_5 = { class: "orderbook-separator__item orderbook-separator__item--spread" }
const _hoisted_6 = { class: "orderbook-separator__label" }
const _hoisted_7 = { class: "orderbook-separator__value" }
const _hoisted_8 = { class: "orderbook-separator__item" }
const _hoisted_9 = { class: "orderbook-separator__label" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { OrderbookSpread } from '@exchange/libs/orderbook/service/src';

import OrderbookAggregation from './OrderbookAggregation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderbookSeparator',
  props: {
  currentSpread: { type: Object as PropType<OrderbookSpread>, required: true },
  lastMatchedPrice: { type: Number, required: true },
  marketPrecision: { type: Number, required: true },
  mini: { type: Boolean, required: true },
  spreadInBps: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const spreadNumber = computed(() => (props.spreadInBps ? props.currentSpread.basicPoints : props.currentSpread.quoteCurrency));
const spreadPrecision = computed(() => (props.spreadInBps ? 4 : props.marketPrecision));
const spreadTitle = computed(() => t(props.spreadInBps ? 'modules.orderbook.separator.spread.basePoints' : 'modules.orderbook.separator.spread.quoteCurrency'));

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modules.orderbook.separator.lastMatchedPriceShort')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ot_number_display, {
          precision: __props.marketPrecision,
          number: __props.lastMatchedPrice
        }, null, 8, ["precision", "number"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(spreadTitle.value), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ot_number_display, {
          precision: spreadPrecision.value,
          number: spreadNumber.value
        }, null, 8, ["precision", "number"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('modules.orderbook.separator.compile')), 1),
      _createVNode(OrderbookAggregation, _mergeProps(_ctx.$attrs, { mini: __props.mini }), null, 16, ["mini"])
    ])
  ]))
}
}

})